// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Calendar from "@insite/mobius/Icons/Calendar";
import Edit from "@insite/mobius/Icons/Edit";
import File from "@insite/mobius/Icons/File";
import Tag from "@insite/mobius/Icons/Tag";
import { actionStyles } from "@keller/Overrides/Widgets/MyListsDetails/MyListsDetailsActions";
import Close from "@keller/XDL/Icons/Close";
import Print from "@keller/XDL/Icons/Print";
import Share from "@keller/XDL/Icons/Share";
import Trash from "@keller/XDL/Icons/Trash";
import { generateButtonLinkStyle, pageTitleStyle } from "@keller/XDL/Utilities";
import { css } from "styled-components";

actionStyles.spinner = {
    size: 12,
    css: css`
        margin-right: 8px;
    `,
};

actionStyles.buttonWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-start;
        white-space: nowrap;
    `,
};

actionStyles.nameText = {
    ...pageTitleStyle,
};

actionStyles.printButton = {
    ...generateButtonLinkStyle(Print),
};

actionStyles.addTagsButton = {
    ...generateButtonLinkStyle(Tag),
};

actionStyles.scheduleButton = {
    ...generateButtonLinkStyle(Calendar),
};

actionStyles.editButton = {
    ...generateButtonLinkStyle(Edit),
};

actionStyles.shareButton = {
    ...generateButtonLinkStyle(Share),
};

actionStyles.addItemButton = {
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        padding: 0 15px;
        margin-right: 10px;
    `,
    variant: "secondary",
};

actionStyles.removeSelectedButton = {
    ...generateButtonLinkStyle(Close),
};

actionStyles.addListButton = {
    css: css`
        margin-left: 5px;
        padding: 0 15px;
    `,
};

actionStyles.nameWrapper = {
    css: css`
        display: flex;
        gap: 12px;
        align-items: flex-start;
    `,
};

actionStyles.copyButton = {
    ...generateButtonLinkStyle("Copy"),
};

actionStyles.exportButton = {
    ...generateButtonLinkStyle("File"),
};

actionStyles.deleteButton = {
    ...generateButtonLinkStyle("Trash"),
};
